/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

*,
:host {
  box-sizing: border-box;
  font-size: 1rem;
  font-family: inherit;
}

:host button,
:host input,
:host optgroup,
:host select,
:host textarea {
  font-family: inherit;
}

davinci-button:focus {
  box-shadow: none;
}

:host {
  display: inline-block;
  vertical-align: middle;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  contain: content;
  outline: 0;
  font-size: 0.8571428571rem;
}
:host > .container {
  cursor: pointer;
}
:host > .container > davinci-button {
  font-size: inherit;
  box-sizing: border-box;
  width: 100%;
  display: block;
}
:host > .container > input[type=file] {
  display: none;
}
:host > .container > input[type=file]:disabled {
  cursor: default;
}

:host([disabled]) {
  pointer-events: none;
  cursor: default;
}

:host([hidden]) {
  display: none;
}`;
export { style };
